import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-action-menu-header',
  template: `
    <p class="app-action-menu__header" [ngClass]="customClass">
      <ng-content></ng-content>
    </p>
  `,
  styleUrls: ['./app-action-menu.component.scss'],
})
export class AppActionMenuHeaderComponent {
  @Input() customClass: string = '';
}
